import { render } from "./VabeneLoyaltyReportPage.vue?vue&type=template&id=6126b947&ts=true"
import script from "./VabeneLoyaltyReportPage.vue?vue&type=script&lang=ts"
export * from "./VabeneLoyaltyReportPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__